import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import type { IconType } from '../../types';

const IconName = 'Interface';

const IconSvg = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.7892 16.2108C5.01756 15.3707 3 12.796 3 9.75C3 6.02208 6.02208 3 9.75 3C12.796 3 15.3707 5.01756 16.2108 7.7892C18.9824 8.62927 21 11.204 21 14.25C21 17.9779 17.9779 21 14.25 21C11.204 21 8.62927 18.9824 7.7892 16.2108ZM14.2662 7.50002C14.3434 7.5002 14.4203 7.50168 14.4969 7.50443C13.6552 5.72833 11.846 4.5 9.75 4.5C6.85051 4.5 4.5 6.85051 4.5 9.75C4.5 11.846 5.72833 13.6552 7.50443 14.4969C7.50206 14.431 7.50064 14.3648 7.50017 14.2984C7.50006 14.2823 7.5 14.2662 7.5 14.25C7.5 10.5221 10.5221 7.5 14.25 7.5C14.2554 7.5 14.2608 7.50001 14.2662 7.50002ZM9.50312 16.4956C10.3448 18.2717 12.154 19.5 14.25 19.5C17.1495 19.5 19.5 17.1495 19.5 14.25C19.5 12.154 18.2717 10.3448 16.4956 9.50312C16.4985 9.58505 16.5 9.66735 16.5 9.75C16.5 13.4779 13.4779 16.5 9.75 16.5C9.66735 16.5 9.58505 16.4985 9.50312 16.4956Z" fill="currentColor"/>
  </svg>
`;

const InterfaceIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.7892 16.2108C5.01756 15.3707 3 12.796 3 9.75C3 6.02208 6.02208 3 9.75 3C12.796 3 15.3707 5.01756 16.2108 7.7892C18.9824 8.62927 21 11.204 21 14.25C21 17.9779 17.9779 21 14.25 21C11.204 21 8.62927 18.9824 7.7892 16.2108ZM14.2662 7.50002C14.3434 7.5002 14.4203 7.50168 14.4969 7.50443C13.6552 5.72833 11.846 4.5 9.75 4.5C6.85051 4.5 4.5 6.85051 4.5 9.75C4.5 11.846 5.72833 13.6552 7.50443 14.4969C7.50206 14.431 7.50064 14.3648 7.50017 14.2984C7.50006 14.2823 7.5 14.2662 7.5 14.25C7.5 10.5221 10.5221 7.5 14.25 7.5C14.2554 7.5 14.2608 7.50001 14.2662 7.50002ZM9.50312 16.4956C10.3448 18.2717 12.154 19.5 14.25 19.5C17.1495 19.5 19.5 17.1495 19.5 14.25C19.5 12.154 18.2717 10.3448 16.4956 9.50312C16.4985 9.58505 16.5 9.66735 16.5 9.75C16.5 13.4779 13.4779 16.5 9.75 16.5C9.66735 16.5 9.58505 16.4985 9.50312 16.4956Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default {
  name: IconName,
  title: IconName,

  IconComponent: InterfaceIcon,
  IconSvg: IconSvg
} as IconType;
